// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"FormGroup_formGroup__2jyVu","basic":"FormGroup_basic__3AEDv"};